import React, { useEffect, useState } from 'react'
import Header from '../components/Header';
import doctor from '../img/doctorIcon.png';
import { Link } from 'react-router-dom';

const Doctors = () => {
    const [details, setDetails] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    const fetchDoctors = async () => {
        try {
            const response = await fetch('https://backend.amarasinghemedicare.com/doctors/doctorpage');

            if (!response) {
                return console.error("Failed to fetch doctors");
            }

            if (response.status === 200) {
                const data = await response.json();
                setDetails(data);
            } else {
                console.error("Failed to fetch doctors, status code:", response.status);
            }
        } catch (error) {
            console.error("Error fetching doctors:", error);
        }
    };

    const filteredDoctors = details.filter((doctor) =>
    (doctor.fullName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        doctor.specialization?.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    useEffect(() => {
        fetchDoctors();
    }, []);

    return (
        <div>
            <Header />

            <div className='mx-2 md:mx-20 my-10 bg-white shadow-2xl flex flex-col justify-center items-center rounded-md px-2 py-3'>
                <h1 className='text-3xl font-light text-fontDark'>Find Your Doctor</h1>

                <div className='w-[%60] md:w-[30%]'>
                    <input
                        type="text"
                        placeholder="Enter Specialization / Doctor"
                        className="w-full bg-white h-11 my-4 rounded-2xl px-4 border border-green shadow-lg"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <div className='bg-blue-200 grid  md:grid-cols-2 gap-2 md:gap-4 p-1 md:p-4 w-full'>
                    {filteredDoctors.map((doctor, index) => (
                        <div key={doctor.id || index} className='flex items-center gap-6 bg-gray-200 w-full p-4 rounded-md'>
                            <div className='w-[40%] md:w-[20%] rounded-lg border-[3px] border-green overflow-hidden'>
                                <img className='w-full'
                                    src={
                                        doctor.profileImage
                                            ? `https://backend.amarasinghemedicare.com/${doctor.profileImage.replace(/\\/g, '/')}`
                                            : require('../assest/images/Doctor.png') // Or use a public path if needed
                                    } alt=""
                                />
                            </div>

                            <div className='flex flex-col md:flex-row justify-between items-start md:items-center w-full gap-2 md:gap-0'>
                                <div className='flex flex-col gap-1'>
                                    <h1 className='text-lg font-semibold'>Dr.{doctor.fullName}</h1>
                                    <h1>Specialization: <span className='font-semibold'>{doctor.specialization}</span></h1>
                                    <h1>Contact: <span className='font-semibold'>{doctor.contact_number}</span></h1>
                                </div>

                                
                                <div>
                                    <Link to={`/doctorShedule?doctorId=${doctor.id}`} className="no-underline inline-block">
                                        <button className='bg-fontDark text-white px-4 py-1 rounded-md hover:scale-105 duration-150'>Channel Now</button>
                                    </Link>
                                </div>
                                
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Doctors